import React, { Component } from 'react';
import { Panel, Row, Col, Checkbox } from 'react-bootstrap';
import DOMPurify from "dompurify";
import moment from 'moment';
import classnames from 'classnames';

class Message extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  toggleMessage = () => {
    const { message, opened, onMessageOpened } = this.props;

    onMessageOpened(message.id, !opened, message.attributes.read);
  };

  showMessage = () => {
    const { message } = this.props;
    const { body } = message.attributes;
    let content = '';

    if (body.length > 40 && !this.props.opened) {
      content = body.slice(0, 40).concat("…");
    } else {
      const links = body.match(/\bhttps?:\/\/\S+[^.]/gi);

      if (links) {
        const link = links[0];

        content = body.replace(link, `<a target="_blank" href="${link}">${link}</a>`);
      } else {
        content = body;
      }
    }

    return <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />;
  };

  render() {
    const { message } = this.props;

    return (
      <Col>
        <Panel
          className={classnames(
            "message-item",
            { open: this.props.opened },
            { unread: !message.attributes.read }
          )}
          onClick={this.toggleMessage}
        >
          <Row>
            <Col xs={3} sm={1}>
              <Checkbox
                inline
                checked={this.props.checked}
                onChange={(e) =>
                  this.props.onMessageChecked(message.id, e.target.checked)
                }
                className="check-message"
              >
                <span className="check-mark" />
              </Checkbox>
            </Col>
            <Col sm={2} className="sender">
              From: {message.attributes.from}
            </Col>
            <Col sm={7}>
              {this.showMessage()}
            </Col>
            <Col sm={2}>
              {moment(message.attributes["created-at"]).format("DD/MM/YYYY")}
            </Col>
          </Row>
        </Panel>
      </Col>
    );
  }
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/my-messages/message.jsx